import { useUserContext } from "./useUserContext";
import { createAxiosApi } from "../Helpers/axiosApiHelper";
import {
	useState,
	useEffect
} from "react";

export function useVolumeToMassConversionService(config) {
	const user = useUserContext(config);
	const [service, setService] = useState(() => {
		return createVolumeToMassConversionService(user, config);
	});

	useEffect(() => {
		setService(createVolumeToMassConversionService(user, config));
	}, [user.authToken]); // eslint-disable-line react-hooks/exhaustive-deps

	return service;
}

function createVolumeToMassConversionService(user, config) {
	const api = createAxiosApi("", user, config);

	function getAll(handleResponse, handleError) {
		api.get("VolumeToMassConversions/")
			.then(handleResponse)
			.catch(handleError);
	}

	function getById(volumeToMassConversionId, handleResponse, handleError) {
		api.get(`VolumeToMassConversions/${volumeToMassConversionId}`)
			.then(handleResponse)
			.catch(handleError);
	}

	function create(volumeToMassConversion, handleResponse, handleError) {
		api.post("VolumeToMassConversions/", volumeToMassConversion)
			.then(handleResponse)
			.catch(handleError);
	}

	function update(volumeToMassConversionId, volumeToMassConversion, handleResponse, handleError) {
		api.put(`VolumeToMassConversions/${volumeToMassConversionId}`, volumeToMassConversion)
			.then(handleResponse)
			.catch(handleError);
	}

	function deleteItem(volumeToMassConversionId, handleResponse, handleError) {
		api.delete(`VolumeToMassConversions/${volumeToMassConversionId}`)
			.then(handleResponse)
			.catch(handleError);
	}

	function importItems(volumeToMassConversions, handleResponse, handleError) {
		api.post("VolumeToMassConversions/import", volumeToMassConversions)
			.then(handleResponse)
			.catch(handleError);
	}

	return {
		getAll,
		getById,
		create,
		update,
		deleteItem,
		importItems
	};
}
